function DeactivateAgentCheck() {
    "use strict";

    this.__type = 'DeactivateAgentCheck:www.veritracks.com';
    this.Id = -1;
    this.Result = -1;
}
if (typeof exports !== 'undefined') {
    module.exports = DeactivateAgentCheck;
}